module.exports = "images/miscellaneous_star.145ed55310b12dd84b0aa7daebf55751.png";